'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from '../../theme/ThemeProvider.js';
import { Button } from '../../primitives/Button/Button.js';
const CYCLE = {
    system: 'light',
    light: 'dark',
    dark: 'system',
};
const ICON = { system: Monitor, light: Sun, dark: Moon };
/** 38px icon button cycling `system → light → dark → system`
 * (CODE_GUIDELINES §8.1, CLAUDE_DESIGN.md app shell). */
export function ThemeToggle({ label, className }) {
    const { theme, setTheme } = useTheme();
    const Icon = ICON[theme];
    return (_jsx(Button, { size: "icon", variant: "ghost", "aria-label": label, onClick: () => setTheme(CYCLE[theme]), className: className, children: _jsx(Icon, { size: 18, "aria-hidden": "true" }) }));
}
